import { useEffect, useState } from "react";
import { MonitorDown } from "lucide-react";
import { toast } from "sonner";

const HEAD_TAGS = [
  ["link", { rel: "manifest", href: "/scout.webmanifest" }],
  ["meta", { name: "theme-color", content: "#0A192F" }],
  ["meta", { name: "apple-mobile-web-app-capable", content: "yes" }],
  ["meta", { name: "apple-mobile-web-app-title", content: "Scout" }],
];

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

const manualHint = () => {
  const ua = navigator.userAgent;
  if (/iPhone|iPad/.test(ua)) return "Tap Share → “Add to Home Screen”.";
  if (/Safari/.test(ua) && !/Chrome|Edg/.test(ua)) return "Safari: File → “Add to Dock”.";
  if (/Edg/.test(ua)) return "Edge menu (…) → Apps → “Install this site as an app”.";
  return "Browser menu (⋮) → Cast, save and share → “Install page as app”.";
};

export const ScoutInstall = () => {
  const [prompt, setPrompt] = useState(null);
  const [installed, setInstalled] = useState(isStandalone());

  useEffect(() => {
    const prev = document.title;
    document.title = "ATFQ Scout";
    const siteApple = document.querySelector('link[rel="apple-touch-icon"]');
    const prevApple = siteApple?.getAttribute("href");
    siteApple?.setAttribute("href", "/icons/scout-apple-180.png");
    const nodes = HEAD_TAGS.map(([tag, attrs]) => {
      const el = document.createElement(tag);
      Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
      document.head.appendChild(el);
      return el;
    });
    const onPrompt = (e) => {
      e.preventDefault();
      setPrompt(e);
    };
    const onInstalled = () => {
      setInstalled(true);
      toast.success("ATFQ Scout installed — find it on your desktop or dock.");
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      document.title = prev;
      if (prevApple) siteApple.setAttribute("href", prevApple);
      nodes.forEach((n) => n.remove());
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed) return null;

  const install = async () => {
    if (prompt) {
      prompt.prompt();
      const { outcome } = await prompt.userChoice;
      if (outcome === "accepted") setPrompt(null);
      return;
    }
    toast("Install ATFQ Scout as an app", { description: manualHint(), duration: 8000 });
  };

  return (
    <button
      type="button"
      data-testid="scout-install-app"
      onClick={install}
      className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-[#0A192F]"
    >
      <MonitorDown className="w-4 h-4" /> Install app
    </button>
  );
};

export default ScoutInstall;
